
import LayoutBlank from '@/layout/LayoutBlank'

export default [{
  // Blank layout
  path: '/auth',
  component: LayoutBlank,
  children: [{
    path: 'login',
    name: 'authLogin',
    component: () => import('@/components/auth/Login')
  }, {
    path: 'passwordreset',
    name: 'authPasswordReset',
    component: () => import('@/components/auth/PasswordReset')
  }, {
    path: 'emailconfirmed',
    name: 'emailConfirmed',
    component: () => import('@/components/auth/EmailConfirmed')
  }]
}]
